import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_ASIA_PROD, COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const msig = {
	// msig_uat
	"msig-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PROD },

	// msig_test
	"msig-test-studio.quote.hk": { 
		appConfig: { tenantId: "msig_test", appId: "covergo_crm" }, 
		envConfig: COVERGO_SAAS_DEV
	},

	// msig_dev
	"studio.msig.dev.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_dev", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.dev.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.dev.ap-east-1.covergo.cloud/api/v1/files"
		}
	},

	// msig_qa
	"studio.msig.qa.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.qa.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.qa.ap-east-1.covergo.cloud/api/v1/files"
		}
	},

	// msig_prod
	"studio.prod.covergoaws.msighkcloud.net": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.covergoaws.msighkcloud.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.covergoaws.msighkcloud.net/api/v1/files"
		}
	},

	// msig_ih
	"msig-ih-studio.dev.asia.covergo.cloud": { 
		appConfig: { tenantId: "msig_ih", appId: "covergo_crm" }, 
		envConfig: COVERGO_SAAS_DEV
	},

	// msig_ih_uat
	"msig-ih-studio.preprod.asia.covergo.cloud": { 
		appConfig: { 
			tenantId: "msigih_preprod", 
			appId: "covergo_crm" 
		}, 
		envConfig: COVERGO_ASIA_PRE_PROD,
		fileSystem: {
			bucketName: "covergo-apse1-preprod-msigih-preprod"
		}
	},
	
}
